"use client";

import { useEffect, useState } from "react";

const BREAKPOINTS = [
  { name: "2xl", minWidth: 1536 },
  { name: "xl", minWidth: 1280 },
  { name: "lg", minWidth: 1024 },
  { name: "md", minWidth: 768 },
  { name: "sm", minWidth: 640 },
  { name: "xs", minWidth: 0 },
] as const;

function getBreakpoint(width: number) {
  for (const breakpoint of BREAKPOINTS) {
    if (width >= breakpoint.minWidth) {
      return breakpoint.name;
    }
  }
  return "unknown";
}

export function BreakpointIndicator() {
  const [viewportWidth, setViewportWidth] = useState<number | null>(null);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  if (viewportWidth === null) {
    return null;
  }

  const breakpoint = getBreakpoint(viewportWidth);

  return (
    <div className="font-ibm-plex-mono pointer-events-none fixed left-4 top-4 z-[1000] rounded-md border border-white/10 bg-black/90 px-3 py-1 text-[11px] uppercase tracking-[0.18em] text-white/80 shadow-[0_4px_18px_rgba(0,0,0,0.25)] flex items-center gap-1">
      <span className="block sm:hidden">Xs</span>
      <span className="hidden sm:inline md:hidden">Sm</span>
      <span className="hidden md:inline lg:hidden">Md</span>
      <span className="hidden lg:inline xl:hidden">Lg</span>
      <span className="hidden xl:inline 2xl:hidden">Xl</span>
      <span className="hidden 2xl:inline">2Xl</span>
      <span className="mx-2 opacity-40">·</span>
      <span>{viewportWidth}px</span>
    </div>
  );
}
